"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _angieslistStyles = require("angieslist-styles");

var _icons = require("@angi/icons");

var _classnames = _interopRequireDefault(require("classnames"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _iconCircleAccount = _interopRequireDefault(require("./icon-circle-account.svg"));

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _strong, _i, _HollowMessageIconV, _img2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EMPTY_ARRAY = [];

var defaultSubNav = function defaultSubNav(responsiveSubNav, leftSubNavItems, rightSubNavItems, showHeaderSubNav) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: showHeaderSubNav ? 'header-bottom' : 'header-bottom-no-display-border'
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "visible-xs",
    style: {
      width: '100%',
      position: 'absolute'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, responsiveSubNav)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "hidden-xs subnav-container-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "pull-left"
  }, leftSubNavItems), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "pull-right header-bottom-right__nav-list"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, (rightSubNavItems || EMPTY_ARRAY).map(function (navItem, index) {
    return /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("li", {
      id: "header-bottom-right--nav-".concat(index),
      className: "pull-left",
      key: index
    }, navItem));
  })))))));
};

var OfficeAppSiteHeader = function OfficeAppSiteHeader(_ref) {
  var _img;

  var children = _ref.children,
      homeLink = _ref.homeLink,
      logo = _ref.logo,
      leftNavItems = _ref.leftNavItems,
      rightNavItems = _ref.rightNavItems,
      responsiveNavItems = _ref.responsiveNavItems,
      responsiveSubNav = _ref.responsiveSubNav,
      leftSubNavItems = _ref.leftSubNavItems,
      rightSubNavItems = _ref.rightSubNavItems,
      rightSideBarMenu = _ref.rightSideBarMenu,
      sideBarMenu = _ref.sideBarMenu,
      hasNotifications = _ref.hasNotifications,
      footer = _ref.footer,
      _ref$showTestUserBann = _ref.showTestUserBanner,
      showTestUserBanner = _ref$showTestUserBann === void 0 ? false : _ref$showTestUserBann,
      appName = _ref.appName,
      className = _ref.className,
      subNav = _ref.subNav,
      customTopBar = _ref.customTopBar,
      customRightSideBarIcon = _ref.customRightSideBarIcon,
      showHeaderSubNav = _ref.showHeaderSubNav,
      resetHeaderSubNav = _ref.resetHeaderSubNav,
      isAngiLeads = _ref.isAngiLeads,
      spId = _ref.spId,
      isInboxEnabled = _ref.isInboxEnabled,
      messagesNotificationCount = _ref.messagesNotificationCount,
      sidebarOpen = _ref.sidebarOpen,
      setSidebarOpen = _ref.setSidebarOpen,
      _ref$delegateUserBann = _ref.delegateUserBanner,
      delegateUserBanner = _ref$delegateUserBann === void 0 ? false : _ref$delegateUserBann;

  var homeLinkForLeadsPages = _urlCatalog["default"].office.leads.homePage(spId);

  var homeLinkForAdsPages = _urlCatalog["default"].office.ads.home(spId);

  var rootUrl = '/';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      rightSidebarOpen = _useState2[0],
      setRightSidebarOpen = _useState2[1];

  function renderLogoImageForHeader(linkForHomePage) {
    return /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
      href: linkForHomePage || homeLink,
      className: "pull-left",
      style: {
        marginRight: _angieslistStyles.stylesTypography.padding.small
      },
      id: "header--logo"
    }, _img || (_img = /*#__PURE__*/_react["default"].createElement("img", {
      alt: "logo",
      src: logo,
      className: "header--logo-img"
    }))));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('site-container', {
      'with--sidebar': sidebarOpen
    }, {
      'with--right-sidebar': rightSidebarOpen
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "site-pusher full-size"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: delegateUserBanner ? 'site-header-with-padding' : 'site-header',
    onMouseLeave: function onMouseLeave() {
      return resetHeaderSubNav();
    }
  }, customTopBar ? customTopBar : null, showTestUserBanner ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    fluid: true,
    className: "bg-warning",
    style: {
      padding: '15px 0',
      color: _angieslistStyles.stylesColors.darkestGray
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-attention icon-lg",
    style: {
      color: _angieslistStyles.stylesColors.orange
    }
  }), ' ', _strong || (_strong = /*#__PURE__*/_react["default"].createElement("strong", null, "You're currently logged in as a Test User!")))) : null, delegateUserBanner ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    fluid: true,
    className: "delegate-header"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "delegate-header-container"
  }, _i || (_i = /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-attention delegate-header-icon"
  })), ' ', /*#__PURE__*/_react["default"].createElement("div", {
    className: "delegate-header-text"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "WARNING! You\u2019re accessing business", ' ', spId, ' ', "during a time-limited session. Double check any changes made.")))) : null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "header-top"
  }, !!sideBarMenu && typeof window !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();
      setSidebarOpen(true);
    },
    className: "header__icon",
    id: "header__icon"
  }, hasNotifications ? /*#__PURE__*/_react["default"].createElement(_icons.HamburgerMenuWithNotification, {
    contentProps: {
      isProVariant: true
    },
    className: "hamburger-menu-notifications",
    viewBox: "0 0 34 34"
  }) : /*#__PURE__*/_react["default"].createElement(_icons.HamburgerMenu, {
    contentProps: {
      isProVariant: true
    },
    className: "hamburger-menu",
    viewBox: "0 0 34 34"
  })) : undefined, logo && typeof window !== 'undefined' ? spId && isAngiLeads ? renderLogoImageForHeader(homeLinkForLeadsPages) : spId && !isAngiLeads ? renderLogoImageForHeader(homeLinkForAdsPages) : renderLogoImageForHeader(rootUrl) : undefined, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "pull-left"
  }, leftNavItems), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "header-top-menu"
  }, rightNavItems), /*#__PURE__*/_react["default"].createElement("div", {
    className: "office-header-nav-icons"
  }, !!sideBarMenu && isInboxEnabled && typeof window !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("a", {
    href: isAngiLeads ? _urlCatalog["default"].office.leads.inbox(spId) : _urlCatalog["default"].office.inbox(spId),
    className: "header__icon",
    id: "header__icon"
  }, messagesNotificationCount && messagesNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_icons.HollowMessageWithNotification, {
    viewBox: "0 0 38 38",
    className: "hollow-message-notifications",
    contentProps: {
      messagesCount: messagesNotificationCount
    }
  }) : _HollowMessageIconV || (_HollowMessageIconV = /*#__PURE__*/_react["default"].createElement(_icons.HollowMessageIconV2, {
    className: "hollow-message-icon",
    viewBox: "0 0 38 38"
  }))) : undefined, !!rightSideBarMenu && typeof window !== 'undefined' ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();
      setRightSidebarOpen(true);
    },
    id: "right-header-icon"
  }, customRightSideBarIcon ? customRightSideBarIcon : _img2 || (_img2 = /*#__PURE__*/_react["default"].createElement("img", {
    className: "visible-xs visible-sm",
    alt: "account-icon",
    src: _iconCircleAccount["default"]
  })))) : undefined), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "header-top-menu visible-xs visible-sm"
  }, responsiveNavItems)), subNav ? subNav : !!leftSubNavItems || !!rightSubNavItems ? defaultSubNav(responsiveSubNav, leftSubNavItems, rightSubNavItems, showHeaderSubNav) : null, /*#__PURE__*/_react["default"].createElement("nav", {
    className: (0, _classnames["default"])('side-bar-menu', {
      'hide-element': !sidebarOpen
    })
  }, sideBarMenu), /*#__PURE__*/_react["default"].createElement("nav", {
    className: (0, _classnames["default"])('right-side-bar-menu', {
      'hide-element': !rightSidebarOpen
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_icons.LightCloseIcon, {
    className: "unified-header--right-side-bar-close-icon",
    id: "unified-header--right-side-bar-close-icon",
    onClick: function onClick() {
      setRightSidebarOpen(false);
    }
  })), rightSideBarMenu))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "site-content ".concat(appName || '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "site-body"
  }, children), footer ? /*#__PURE__*/_react["default"].createElement("footer", {
    className: "site-footer"
  }, footer) : undefined), /*#__PURE__*/_react["default"].createElement("div", {
    className: "site-cache",
    id: "site-cache",
    onClick: function onClick() {
      setSidebarOpen(false);
      setRightSidebarOpen(false);
    }
  })));
};

var _default = (0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
})(OfficeAppSiteHeader);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/OfficeAppSiteHeader.js
// module id = 3678
// module chunks = 25